export default __webpack_public_path__ + "static/media/bg4.c0dab574.png";